/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemInstanceRef,
  ItemInstanceRefOptional,
  ItemInstanceRefMetaI,
  ItemInstanceRefTrackedI,
} from "./item-instance-ref";
import {
  ItemInstanceRefTracked,
  ItemInstanceRefMeta,
} from "./item-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemInstanceStockChangeFull,
  ItemInstanceStockChangeFullOptional,
  ItemInstanceStockChangeFullMetaI,
  ItemInstanceStockChangeFullTrackedI,
} from "./item-instance-stock-change-full";
import {
  ItemInstanceStockChangeFullTracked,
  ItemInstanceStockChangeFullMeta,
} from "./item-instance-stock-change-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";
// May contain unused imports in some cases
// @ts-ignore
import type {
  StockChangeType,
  StockChangeTypeOptional,
  StockChangeTypeMetaI,
  StockChangeTypeTrackedI,
} from "./stock-change-type";
import {
  StockChangeTypeTracked,
  StockChangeTypeMeta,
} from "./stock-change-type";

/**
 *
 * @export
 * @interface PurchaseStockedItemDTO
 */
export interface PurchaseStockedItemDTOOptional extends ItemInstanceStockChangeFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseStockedItemDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseStockedItemDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseStockedItemDTO
   */
  assignId?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseStockedItemDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof PurchaseStockedItemDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PurchaseStockedItemDTO
   */
  changeAmount?: number;
  /**
   *
   * @type {StockChangeType}
   * @memberof PurchaseStockedItemDTO
   */
  stockChangeType?: StockChangeType;
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof PurchaseStockedItemDTO
   */
  itemInstanceId?: ItemInstanceRefOptional;
}

export interface PurchaseStockedItemDTO
  extends PurchaseStockedItemDTOOptional, ItemInstanceStockChangeFull {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseStockedItemDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseStockedItemDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseStockedItemDTO
   */
  assignId: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseStockedItemDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof PurchaseStockedItemDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PurchaseStockedItemDTO
   */
  changeAmount: number;
  /**
   *
   * @type {StockChangeType}
   * @memberof PurchaseStockedItemDTO
   */
  stockChangeType: StockChangeType;
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof PurchaseStockedItemDTO
   */
  itemInstanceId: ItemInstanceRef;
}

export interface PurchaseStockedItemDTOTrackedI extends ItemInstanceStockChangeFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseStockedItemDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseStockedItemDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseStockedItemDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseStockedItemDTO
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseStockedItemDTO
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseStockedItemDTO
   */
  changeAmount?: number;
  changeAmountIsSet: boolean;
  /**
   *
   * @type {StockChangeType}
   * @memberof PurchaseStockedItemDTO
   */
  stockChangeType?: StockChangeType;
  stockChangeTypeIsSet: boolean;
  /**
   *
   * @type {ItemInstanceRef}
   * @memberof PurchaseStockedItemDTO
   */
  itemInstanceId?: ItemInstanceRefTrackedI;
  itemInstanceIdIsSet: boolean;
}

transformDatesMap.set(
  "PurchaseStockedItemDTO",
  function (model: PurchaseStockedItemDTO) {
    if (typeof model.purchaseDate == "string")
      model.purchaseDate = new Date(model.purchaseDate);
    const transformDatesitemInstanceId =
      transformDatesMap.get("ItemInstanceRef");
    if (transformDatesitemInstanceId && model.itemInstanceId) {
      transformDatesitemInstanceId(model.itemInstanceId);
    }
  },
);

export type PurchaseStockedItemDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  changeAmount: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  stockChangeType: PropertyMeta<StockChangeTypeMetaI>;
  //isDate: false
  //isDatetime: false
  itemInstanceId: PropertyMeta<ItemInstanceRefMetaI>;
}>;

export var PurchaseStockedItemDTOMeta: PurchaseStockedItemDTOMetaI =
  {} as PurchaseStockedItemDTOMetaI;
PurchaseStockedItemDTOMeta = typeMeta("PurchaseStockedItemDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  changeAmount: propertyMeta(
    "changeAmount",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  stockChangeType: propertyMeta(
    "stockChangeType",
    false,
    true,
    false,
    StockChangeTypeMeta,
  ),
  itemInstanceId: propertyMeta(
    "itemInstanceId",
    false,
    true,
    false,
    ItemInstanceRefMeta,
  ),
});

const metaI = PurchaseStockedItemDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ItemInstanceStockChangeFullMeta]);
  metaI.isDeleted.inheritedFrom = ItemInstanceStockChangeFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = ItemInstanceStockChangeFullMeta.isNew;
  metaI.assignId.inheritedFrom = ItemInstanceStockChangeFullMeta.assignId;
  metaI.purchasableState.inheritedFrom =
    ItemInstanceStockChangeFullMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom =
    ItemInstanceStockChangeFullMeta.purchaseDate;
  metaI.changeAmount.inheritedFrom =
    ItemInstanceStockChangeFullMeta.changeAmount;
  metaI.stockChangeType.inheritedFrom =
    ItemInstanceStockChangeFullMeta.stockChangeType;
  metaI.itemInstanceId.inheritedFrom =
    ItemInstanceStockChangeFullMeta.itemInstanceId;
});

export class PurchaseStockedItemDTOTracked
  extends ItemInstanceStockChangeFullTracked
  implements PurchaseStockedItemDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  changeAmount__I?: number = undefined;
  changeAmountIsSet: boolean = false;
  set changeAmount(v: undefined | number) {
    if (v !== undefined) {
      this.changeAmount__I = v;
      this.changeAmountIsSet = true;
    } else {
      this.changeAmount__I = v || undefined;
      this.changeAmountIsSet = true;
    }
    this.changeTracker = true;
  }
  get changeAmount() {
    return this.changeAmount__I;
  }
  stockChangeType__I?: StockChangeType = undefined;
  stockChangeTypeIsSet: boolean = false;
  set stockChangeType(v: undefined | StockChangeType) {
    if (v !== undefined) {
      this.stockChangeType__I = v;
      this.stockChangeTypeIsSet = true;
    } else {
      this.stockChangeType__I = v || undefined;
      this.stockChangeTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get stockChangeType() {
    return this.stockChangeType__I;
  }
  itemInstanceId__I?: ItemInstanceRefTracked = undefined;
  itemInstanceIdIsSet: boolean = false;
  set itemInstanceId(v: undefined | ItemInstanceRefTracked) {
    if (v !== undefined) {
      this.itemInstanceId__I = v;
      this.itemInstanceIdIsSet = true;
    } else {
      this.itemInstanceId__I = v || undefined;
      this.itemInstanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get itemInstanceId() {
    return this.itemInstanceId__I;
  }
  constructor(
    config?: PurchaseStockedItemDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.itemInstanceId?.setIds();
  }
  assignFrom(
    config: PurchaseStockedItemDTOOptional,
    options?: AssignOptions,
  ): PurchaseStockedItemDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.changeAmount &&
      this.changeAmountApplyFilter(optionsRequired.filter)
    ) {
      this.changeAmount = config.changeAmount;
      if (optionsRequired.unassign) this.changeAmountIsSet = false;
      else this.changeAmountIsSet = true;
    }
    if (
      config.stockChangeType &&
      this.stockChangeTypeApplyFilter(optionsRequired.filter)
    ) {
      this.stockChangeType = config.stockChangeType;
      if (optionsRequired.unassign) this.stockChangeTypeIsSet = false;
      else this.stockChangeTypeIsSet = true;
    }
    if (
      config.itemInstanceId &&
      this.itemInstanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.itemInstanceId = new ItemInstanceRefTracked(
        config.itemInstanceId,
        options,
      );
      if (optionsRequired.unassign) this.itemInstanceIdIsSet = false;
      else this.itemInstanceIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PurchaseStockedItemDTOTrackedI {
    const cloned = {} as PurchaseStockedItemDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.changeAmountIsSetDeep() &&
      this.changeAmountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.changeAmountIsSet = true;
      cloned.changeAmount = this.changeAmount;
    } else {
      //cloned.changeAmountIsSet = false
    }
    if (
      this.stockChangeTypeIsSetDeep() &&
      this.stockChangeTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stockChangeTypeIsSet = true;
      cloned.stockChangeType = this.stockChangeType;
    } else {
      //cloned.stockChangeTypeIsSet = false
    }
    if (
      this.itemInstanceIdIsSetDeep() &&
      this.itemInstanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemInstanceIdIsSet = true;
      cloned.itemInstanceId = this.itemInstanceId?.removeUnset(filter);
    } else {
      //cloned.itemInstanceIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PurchaseStockedItemDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.changeAmountApplyFilter(filter)) this.changeAmountIsSet = false;

    if (!this.stockChangeTypeApplyFilter(filter))
      this.stockChangeTypeIsSet = false;

    if (!this.itemInstanceIdApplyFilter(filter))
      this.itemInstanceIdIsSet = false;
    this.itemInstanceId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseStockedItemDTOMeta.isDeleted,
      PurchaseStockedItemDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseStockedItemDTOMeta.isNew,
      PurchaseStockedItemDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseStockedItemDTOMeta.assignId,
      PurchaseStockedItemDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseStockedItemDTOMeta.purchasableState,
      PurchaseStockedItemDTOMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseStockedItemDTOMeta.purchaseDate,
      PurchaseStockedItemDTOMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  changeAmountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseStockedItemDTOMeta.changeAmount,
      PurchaseStockedItemDTOMeta,
      this.changeAmount,
      this,
    );
  }
  changeAmountIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.changeAmountIsSet && this.changeAmountApplyFilter(filter))
      return true;

    return false;
  }
  stockChangeTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseStockedItemDTOMeta.stockChangeType,
      PurchaseStockedItemDTOMeta,
      this.stockChangeType,
      this,
    );
  }
  stockChangeTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.stockChangeTypeIsSet && this.stockChangeTypeApplyFilter(filter))
      return true;

    return false;
  }
  itemInstanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseStockedItemDTOMeta.itemInstanceId,
      PurchaseStockedItemDTOMeta,
      this.itemInstanceId,
      this,
    );
  }
  itemInstanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemInstanceIdIsSet && this.itemInstanceIdApplyFilter(filter))
      return true;
    return this.itemInstanceId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.changeAmountIsSetDeep(filter)) return true;
    if (this.stockChangeTypeIsSetDeep(filter)) return true;
    if (this.itemInstanceIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
